
import { Options, Vue } from 'vue-class-component';
import Popper from 'vue3-popper';
import EventBusService from "@/services/EventBusService";
import {
    Appointment,
    AppointmentEnrollment,
    AppointmentEnrollmentState,
    AppointmentEnrollmentStatesMap
} from "@/data/appointments";
import {
    formatDate,
    formatDatetime,
    formatDateWithDayLabel,
    formatTime,
    formatToNow,
    isDatetimeInNextDuration,
    isPast
} from "@/utils/helpers";

@Options({
    props: {
        appointment: {
            type: Object,
            requuired: true,
        },
        appointmentEnrollmentStates: {
            type: Object,
            required: false,
            default: null,
        },
        closeModalOnEnrollmentChange: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    components: {
        Popper,
    },
})
export default class UserCourseUpcomingAppointment extends Vue {
    appointment!: Appointment
    appointmentEnrollmentStates!: AppointmentEnrollmentStatesMap|null
    closeModalOnEnrollmentChange!: boolean

    timeInterval: number|null = null

    timeToStart = ''

    // loading = true

    get enrollmentLoading(): boolean {
        return this.enrollmentState?.loading || false;
    }

    get isEnrolled() {
        return !!this.enrollment && !this.enrollment.waiting;
    }

    get isWaiting() {
        return !!this.enrollment && this.enrollment.waiting;
    }

    get isWaitingAndCanEnroll() {
        return this.isWaiting && this.enrollment?.appointment_participants_limit_reached === false;
    }

    get enrollment(): AppointmentEnrollment|null {
        return this.enrollmentState?.enrollment || null;
    }

    get enrollmentState(): AppointmentEnrollmentState|null {
        return this.appointmentEnrollmentStates?.[this.appointment.id] || null;
    }

    get isCancelled() {
        return this.appointment.cancelled;
    }

    get date() {
        return formatDateWithDayLabel(this.appointment.start);
    }
    get timeStart() {
        return formatTime(this.appointment.start);
    }
    updateTimeToStart() {
        this.timeToStart = formatToNow(this.appointment.start, { addSuffix: true });
    }

    get isPast() {
        return isPast(this.appointment.start);
    }
    get enrollmentDeadlineReached() {
        return isPast(this.appointment.enrollment_deadline);
    }
    get withdrawalDeadlineReached() {
        return isPast(this.appointment.withdrawal_deadline);
    }

    get renderTextItalic() {
        return this.isPast || this.isCancelled;
    }

    onEnrollClick() {
        EventBusService.$emit('modals.appointment.details.open', {
            appointment: this.appointment.id, // pass appointment ID so modal will load the appointment details itself (including course relation)
            closeOnEnrollmentChange: true,
        });
    }

    onWithdrawClick() {
        EventBusService.$emit('modals.appointment.details.open', {
            appointment: this.appointment.id, // pass appointment ID so modal will load the appointment details itself (including course relation)
            closeOnEnrollmentChange: true,
        });
    }

    mounted() {
        if( isDatetimeInNextDuration(this.appointment.start, { days: 14 }) ) {
            this.updateTimeToStart();
            this.timeInterval = setInterval(() => {
                this.updateTimeToStart();
            }, 1000);
        }
    }
    beforeUnmount() {
        if( this.timeInterval ) {
            clearInterval(this.timeInterval);
        }
    }
}
